import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddCustomerDto } from 'src/app/models/dialog-dto/add-customer.dto';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogFormService } from 'src/app/services/dialog-form.service';
import { DialogService } from 'src/app/services/dialog.service';
import { DialogAddClientComponent } from '../dialog-add-client/dialog-add-client.component';

interface DeleteCustomerDialogData {
  guid: string;
}

@Component({
  selector: 'app-dialog-delete-customer',
  templateUrl: './dialog-delete-customer.component.html',
  styleUrl: './dialog-delete-customer.component.scss'
})
export class DialogDeleteCustomerComponent {
  guid: string = '';
  customer: AddCustomerDto = {
    client: {
      id: 0
    },
    company: {
      name: '',
      country: '',
      city: '',
      zipcode: '',
      street: '',
    },
  };

  constructor(
    private dialogFormService: DialogFormService,
    private dialogService: DialogService,
    public dialogRef: MatDialogRef<DialogAddClientComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteCustomerDialogData
  ) {
    if (data?.guid && data.guid !== '') {
      this.guid = data.guid;
      this.dialogService
        .getEditCustomerData(data.guid)
        .subscribe((data) => (this.customer = data));
    }
  }

  confirm() {
    this.dialogFormService.confirmDeleteCustomerForm(this.guid).subscribe(result => {
      if (result.success) {
        this.dialogRef.close(result.success)
      }
    });
  }
}
